import { render, staticRenderFns } from "./YRoom.vue?vue&type=template&id=2147f08c&"
import script from "./YRoom.vue?vue&type=script&lang=js&"
export * from "./YRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports